import { RootState } from 'redux/store';
import { createSelector } from 'reselect';
import { ILookup } from '../../../@types/profile-types';

const addressLookupState = (state: RootState) => state.profileLookups.addressLookup;

const selectAddressLookupState = createSelector([addressLookupState], (state) => {
    return state;
});

export const selectAddressLookupLoading = createSelector(selectAddressLookupState, (state) => {
    return state.loading;
});

export const selectAddressLookupData = createSelector(selectAddressLookupState, (state) => {
    const copy: ILookup[] = JSON.parse(JSON.stringify(state.data));
    copy.push({ value: 'other', display: 'Other' });
    return copy;
});

export const selectAddressLookupError = createSelector(selectAddressLookupState, (state) => {
    return state.error;
});
